export const InternalRef = {
	eventsList: 'events-list',
};
